var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialYoutube = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none",
    viewBox: "0 0 20 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M18.922 2.409A2.32 2.32 0 0 0 17.295.772C15.85.375 10.073.375 10.073.375s-5.777 0-7.222.382A2.37 2.37 0 0 0 1.224 2.41C.844 3.86.844 6.874.844 6.874s0 3.028.38 4.465a2.32 2.32 0 0 0 1.627 1.637c1.46.397 7.222.397 7.222.397s5.778 0 7.222-.382a2.32 2.32 0 0 0 1.627-1.636c.38-1.453.38-4.466.38-4.466s.015-3.028-.38-4.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.037 6.875 8.233 4.092V9.66z"
  })));
};
export { SvgSocialYoutube as ReactComponent };